export default "__VITE_ASSET__BbcizUTF__"